import React from "react";

import { Link, useNavigate } from "react-router-dom";

import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaBlog,
  FaCalendarAlt,
  FaUser,
} from "react-icons/fa";

import {
  // collection,
  deleteDoc,
  doc,
} from "firebase/firestore";

import useBlogs from "../../../hooks/useBlogs";

import { formatBlogDate } from "../../../data/blogs";

import { db } from "../../../firebase/firebase";

import "./Blogs.css";

const Blogs = () => {
  const navigate = useNavigate();

  const { blogs, loading, error } = useBlogs(false);

  // =========================================================
  // DELETE BLOG
  // =========================================================

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this blog?",
    );

    if (!confirmed) {
      return;
    }

    try {
      await deleteDoc(doc(db, "blogs", id));

      window.location.reload();
    } catch (err) {
      console.error("Error deleting blog:", err);

      alert("Unable to delete blog. Please try again.");
    }
  };

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <div className="blogs-loading">
        <div className="blogs-spinner"></div>

        <p>Loading blogs...</p>
      </div>
    );
  }

  // =========================================================
  // ERROR
  // =========================================================

  if (error) {
    return (
      <div className="blogs-error">
        <FaBlog />

        <h2>Unable to load blogs</h2>

        <p>{error}</p>
      </div>
    );
  }

  // =========================================================
  // PAGE
  // =========================================================

  return (
    <div className="admin-blogs-page">
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="admin-blogs-header">
        <div>
          <h1>Blogs</h1>

          <p>Manage your website blog articles.</p>
        </div>

        <Link to="/admin/blogs/add" className="add-blog-button">
          <FaPlus />
          Add New Blog
        </Link>
      </div>

      {/* =====================================================
          EMPTY
      ===================================================== */}

      {blogs.length === 0 ? (
        <div className="admin-blogs-empty">
          <FaBlog />

          <h2>No blogs found</h2>

          <p>Create your first blog article.</p>

          <Link to="/admin/blogs/add" className="add-blog-button">
            <FaPlus />
            Create Blog
          </Link>
        </div>
      ) : (
        <div className="admin-blogs-table-wrapper">
          <table className="admin-blogs-table">
            <thead>
              <tr>
                <th>Blog</th>

                <th>Category</th>

                <th>Author</th>

                <th>Date</th>

                <th>Status</th>

                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {blogs.map((blog) => (
                <tr key={blog.id}>
                  {/* BLOG */}

                  <td>
                    <div className="admin-blog-info">
                      {blog.image ? (
                        <img
                          src={blog.image}
                          alt={blog.title}
                          className="admin-blog-thumbnail"
                        />
                      ) : (
                        <div className="admin-blog-no-image">
                          <FaBlog />
                        </div>
                      )}

                      <div>
                        <h3>{blog.title || "Untitled Blog"}</h3>

                        <p>{blog.slug}</p>
                      </div>
                    </div>
                  </td>

                  {/* CATEGORY */}

                  <td>
                    <span className="blog-category">
                      {blog.category || "Sports"}
                    </span>
                  </td>

                  {/* AUTHOR */}

                  <td>
                    <span className="blog-author">
                      <FaUser />

                      {blog.author || "Admin"}
                    </span>
                  </td>

                  {/* DATE */}

                  <td>
                    <span className="blog-date">
                      <FaCalendarAlt />

                      {formatBlogDate(blog.date || blog.createdAt)}
                    </span>
                  </td>

                  {/* STATUS */}

                  <td>
                    {blog.published ? (
                      <span className="blog-status published">Published</span>
                    ) : (
                      <span className="blog-status draft">Draft</span>
                    )}
                  </td>

                  {/* ACTIONS */}

                  <td>
                    <div className="blog-actions">
                      {/* VIEW */}

                      {blog.published && blog.slug && (
                        <button
                          type="button"
                          className="blog-action view"
                          title="View Blog"
                          onClick={() =>
                            window.open(`/blogs/${blog.slug}`, "_blank")
                          }
                        >
                          <FaEye />
                        </button>
                      )}

                      {/* EDIT */}

                      <button
                        type="button"
                        className="blog-action edit"
                        title="Edit Blog"
                        onClick={() => navigate(`/admin/blogs/${blog.id}/edit`)}
                      >
                        <FaEdit />
                      </button>

                      {/* DELETE */}

                      <button
                        type="button"
                        className="blog-action delete"
                        title="Delete Blog"
                        onClick={() => handleDelete(blog.id)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Blogs;
